export default __webpack_public_path__ + "static/media/misc-bathtubA-768w.890d8f33.webp";